import React, { Component, Fragment } from 'react';
import styled, { keyframes } from 'styled-components';
import { MdClose } from 'react-icons/md';
import { OfferCountdown, OfferTimer, FlipOfferTimer } from '../CountDown';
import { CrossLine } from '../../Pricing/PrimePackage/styles';

const NoticeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const SnackBarDiv = styled.div`
  z-index: 101;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #333;
  background: #f4c150;
  border-color: #f4c150;
  text-align: center;
  overflow: hidden;
  box-shadow: 0 0 5px black;
  animation: ${NoticeAnimation} 1s linear alternate;
  padding: 7px;
  @media (max-width: 450px) {
  }
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 5px;
  }
`;

export const CloseButton = styled(MdClose)`
  font-size: 1.2em;
  right: 2%;
  position: absolute;
  cursor: pointer;
  top: 14px;
  :hover {
    color: #999;
  }
  @media (max-width: 600px) {
    top: 22px;
  }
`;

export const SnakBarCloseButton = styled(MdClose)`
  font-size: 1.2em;
  right: 1%;
  position: absolute;
  cursor: pointer;
  top: 10px;
  :hover {
    color: #999;
  }
  @media (max-width: 600px) {
    top: 9px;
  }
`;

export const ActionButton = styled.button`
  font-size: 14px;
  border-radius: 4px;
  border: 1px;
  background: #fff;
  min-width: 100px;
  padding: 5px 10px;
  margin-left: 8px;
  :focus {
    outline: 0;
  }
`;

const PackageSnackBarDiv = styled(SnackBarDiv)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: 600px) {
    display: inline;
  }
  @media (max-width: 360px) {
    font-size: 12px;
  }
`;

const PackageBanner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => (props.isNoMargin ? '0px' : '20px')};
  margin-top: ${(props) => (props.isNoMargin && props.noMarginTop !== true ? '15px' : '0px')};
`;

const OfferPrice = styled.p`
  margin: 0 6px 0 0;
  font-size: 20px;
  color: #fff;
  text-align: center;
  padding: 4px 8px;
  background: linear-gradient(to right, #dc2424, #4a569d);
  border-radius: 4px;
`;

export const TimerContainer = styled.div`
  display: flex;
  color: ${(props) => (props.light ? 'var(--light)' : 'var(--dark)')};
  font-size: ${(props) => (props.minimalOffer ? '15px' : props.type === 'dboard-prime-bar' ? '18px' : '16px')};
  gap: ${(props) => (props.minimalGap ? '8px' : '10px')};
  @media (min-width: 576px) {
    gap: ${(props) => (props.minimalGap ? '8px' : '12px')};
  }
  @media (min-width: 768px) {
    gap: ${(props) => (props.minimalGap ? '8px' : '15px')};
  }
`;

export const OfferText = styled.span`
  margin: 0px;
`;

export const SnackBar = styled.div`
  z-index: 101;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f49c3f;
  color: #333;
  background-color: #f4c150;
  border-color: #f4c150;
  text-align: center;
  overflow: hidden;
  box-shadow: 0 0 5px black;
  animation: ${NoticeAnimation} 1s linear alternate;
  padding: 10px;
  @media (max-width: 450px) {
    padding: 5px 0;
  }
`;

export class PromoTrialSnackBar extends Component {
  render() {
    let { snackbarRef, promoCode, name, remainingDays, handleSnackBarClose, paymentStatus, upgradePremium } = this.props;
    let contentDiv = null;
    if (promoCode && promoCode.code && promoCode.discount) {
      contentDiv = (
        <Fragment>
          {promoCode.description ? (
            <span dangerouslySetInnerHTML={{ __html: promoCode.description }}></span>
          ) : (
            <Fragment>
              Congratulations! A gift for your determination | Use code
              <strong> {promoCode.code} </strong> and get
              <strong> {promoCode.discount}% offer. </strong>
              {promoCode.expiresAt && promoCode.showExpiry && (
                <strong>
                  {' '}
                  &nbsp; Ends in <OfferCountdown expiresAt={promoCode.expiresAt} />{' '}
                </strong>
              )}
            </Fragment>
          )}
        </Fragment>
      );
    } else if (remainingDays < 2 && paymentStatus !== true) {
      contentDiv = (
        <Fragment>
          Your free trial ends
          <span style={{ color: '#fff' }}> {remainingDays === 0 ? 'Today' : remainingDays === 1 && 'Tomorrow'}</span> | Become a Prime member
        </Fragment>
      );
    }
    return (
      <SnackBarDiv ref={snackbarRef}>
        Hey <span>{name.charAt(0).toUpperCase() + name.slice(1)}</span>!&nbsp;
        {contentDiv}
        <ActionButton onClick={() => upgradePremium()}>Upgrade now</ActionButton>
        <CloseButton onClick={handleSnackBarClose} />
      </SnackBarDiv>
    );
  }
}

export const PackageSnackBar = ({ offerName, offerMessage, trialExpiry, homePage, snackbarRef, handleSnackBarPricingLink, handleSnackBarClose, offerPrice, currencySymbol }) => (
  <PackageSnackBarDiv ref={snackbarRef}>
    <TimerContainer>
      <OfferTimer />
    </TimerContainer>
    <strong>{trialExpiry && ' Your Free Trial Expired '}</strong> | <OfferText>{offerName} Offer |</OfferText> {offerMessage}{' '}
    <span style={{ margin: '0 2px 0 5px', color: '#121212' }}>{currencySymbol}</span>
    <span style={{ color: '#121212', marginRight: '3px' }}>{offerPrice}</span>(One Year Access)
    {homePage ? '' : <ActionButton onClick={handleSnackBarPricingLink}>Buy now</ActionButton>}
    <CloseButton onClick={handleSnackBarClose} />
  </PackageSnackBarDiv>
);

export const PackageBannerOffer = ({ offerPrice, currencySymbol }) => (
  <PackageBanner>
    <OfferPrice>
      {currencySymbol}
      <span style={{ marginRight: '3px' }}>{offerPrice}</span>
    </OfferPrice>
    <TimerContainer>
      <OfferTimer />
    </TimerContainer>
  </PackageBanner>
);

export const PrimeOffer = ({
  specialOffer,
  isNoMargin,
  noMarginTop,
  noLineHeight,
  minimalGap,
  minimalOffer,
  colonSize,
  numDays,
  light,
  tempTimer,
  type,
  timerBg,
  offerEndTime,
  variant,
  courseTheme,
}) => (
  <PackageBanner isNoMargin={isNoMargin} noMarginTop={noMarginTop}>
    <TimerContainer specialOffer={specialOffer} minimalGap={minimalGap} light={light} minimalOffer={minimalOffer}>
      {type === 'dboard-prime-bar' || type === 'header-prime-bar' ? (
        <FlipOfferTimer type={type} variant={variant} courseTheme={courseTheme} dayCount={numDays ? numDays : 2} offerEndTime={offerEndTime} />
      ) : (
        <OfferTimer
          type={type}
          dayCount={numDays ? numDays : 2}
          specialOffer={specialOffer}
          colonSize={colonSize}
          noLineHeight={noLineHeight}
          tempTimer={tempTimer}
          timerBg={timerBg}
        />
      )}
    </TimerContainer>
  </PackageBanner>
);

export const PromoCodeSnackBar = ({ handleSnackBarClose }) => (
  <PackageSnackBarDiv>
    <TimerContainer>
      <OfferTimer />
    </TimerContainer>
    <OfferText>It's placement time!</OfferText> Use promo code <ActionButton>PLACEMENT</ActionButton> and get 20% OFF on any courses
    <CloseButton onClick={handleSnackBarClose} />
  </PackageSnackBarDiv>
);

export const SpecialOffer = ({ history, handleAllAccessClick, pricing, isFromHome, priceDetails, handleSnackBarClose, showSnakeBar }) => (
  <Fragment>
    {showSnakeBar ? (
      <SnackBar>
        {isFromHome ? (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <strong>
              {priceDetails.offerDetails.offerName} | {priceDetails.offerDetails.offerDescription} {priceDetails.currencySymbol} {priceDetails.offerPrice} / year
            </strong>{' '}
            <div>
              {' '}
              <strong>
                ({priceDetails.listPrice}) <CrossLine style={{ width: 60 }} />{' '}
              </strong>
            </div>
            <ActionButton
              onClick={() => {
                history.push('/pricing');
              }}
            >
              {priceDetails.offerDetails.btnName}
            </ActionButton>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <strong>
              {priceDetails.offerDetails.offerName} | {priceDetails.offerDetails.offerDescription} {priceDetails.currencySymbol} {priceDetails.offerPrice} / year
            </strong>{' '}
            <div>
              {' '}
              <strong>
                ({priceDetails.listPrice}) <CrossLine style={{ width: 60 }} />{' '}
              </strong>
            </div>
            <ActionButton
              onClick={() => {
                history.push('/pricing');
              }}
            >
              {priceDetails.offerDetails.btnName}
            </ActionButton>
          </div>
        )}
        <SnakBarCloseButton onClick={handleSnackBarClose} />
        {/* <MdClose style={{position:'absolute'}}></MdClose> */}
      </SnackBar>
    ) : null}
  </Fragment>
);
